(function () {
  if (window._skmATC) return;
  window._skmATC = true;

  var overlay, closeBtn, optionsEl, addBtn, msgEl, cartLink, imgEl, nameEl, priceEl;
  var state = {};

  function fmt(c) { return '$' + (c / 100).toFixed(2); }

  function getEls() {
    overlay  = document.getElementById('skm-overlay');
    closeBtn = document.getElementById('skm-close');
    optionsEl= document.getElementById('skm-options');
    addBtn   = document.getElementById('skm-add-btn');
    msgEl    = document.getElementById('skm-msg');
    cartLink = document.getElementById('skm-cart-link');
    imgEl    = document.getElementById('skm-img');
    nameEl   = document.getElementById('skm-name');
    priceEl  = document.getElementById('skm-price');
  }

  function setup() {
    getEls();
    if (!overlay) return;
    if (overlay._skmSetup) return;
    overlay._skmSetup = true;
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    addBtn && addBtn.addEventListener('click', doAdd);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  // Capture-phase: handles both ATC open and X close — cannot be blocked
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;

    // X close button
    if (t.id === 'skm-close' || (t.closest && t.closest('#skm-close'))) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      close();
      return;
    }

    // ATC button
    var btn = t.closest ? t.closest('.toe-atc-btn') : null;
    if (!btn) return;
    e.stopPropagation();
    openModal(
      btn.getAttribute('data-handle'),
      (function () {
        var card = btn.closest('article');
        var img = card && card.querySelector('.toe-product-image-link img');
        return img ? img.src : '';
      }()),
      (function () {
        var card = btn.closest('article');
        var h = card && (card.querySelector('h2 a') || card.querySelector('h2'));
        return h ? h.textContent.trim() : '';
      }())
    );
  }, true);

  function openModal(handle, imgSrc, name) {
    setup();
    getEls(); // always refresh refs
    if (!overlay) return;
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    optionsEl.innerHTML = '<div style="text-align:center;padding:20px;color:#999;font-size:13px">Loading…</div>';
    addBtn.disabled = true;
    addBtn.textContent = 'Select a size';
    msgEl.textContent = '';
    msgEl.className = 'skm-msg';
    cartLink.className = 'skm-cart-link';
    imgEl.src = imgSrc || '';
    nameEl.textContent = name || '';
    priceEl.textContent = '';
    state = { product: null, selections: {}, variantId: null };

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        state.product = p;
        priceEl.textContent = fmt(p.price_min);
        renderOptions(p);
      })
      .catch(function () {
        optionsEl.innerHTML = '<p style="color:#c00;text-align:center;padding:12px">Failed to load. <a href="/products/' + handle + '">Open page</a></p>';
      });
  }

  function renderOptions(product) {
    var html = '';
    product.options.forEach(function (opt, i) {
      html += '<div class="skm-option-group"><p class="skm-option-label">' + opt.name + '</p><div class="skm-pills">';
      opt.values.forEach(function (val) {
        html += '<button class="skm-pill" data-option="' + i + '" data-value="' + val + '" type="button">' + val + '</button>';
      });
      html += '</div></div>';
    });
    optionsEl.innerHTML = html;
    optionsEl.querySelectorAll('.skm-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-option'));
        optionsEl.querySelectorAll('.skm-pill[data-option="' + idx + '"]').forEach(function (p) { p.classList.remove('selected'); });
        this.classList.add('selected');
        state.selections[idx] = this.getAttribute('data-value');
        updateVariant();
      });
    });
  }

  function updateVariant() {
    var p = state.product;
    if (!p) return;
    var n = p.options.length, allSel = true;
    for (var i = 0; i < n; i++) { if (state.selections[i] === undefined) { allSel = false; break; } }
    if (!allSel) { addBtn.disabled = true; addBtn.textContent = 'Select all options'; return; }
    var variant = null;
    for (var j = 0; j < p.variants.length; j++) {
      var v = p.variants[j], match = true;
      for (var k = 0; k < n; k++) { if (v['option' + (k + 1)] !== state.selections[k]) { match = false; break; } }
      if (match) { variant = v; break; }
    }
    if (!variant) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
    state.variantId = variant.id;
    if (!variant.available) { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; return; }
    priceEl.textContent = fmt(variant.price);
    addBtn.disabled = false;
    addBtn.textContent = 'Add to Cart';
  }

  function doAdd() {
    if (!state.variantId || addBtn.disabled) return;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    msgEl.textContent = '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: state.variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Error'); });
        return r.json();
      })
      .then(function () {
        addBtn.textContent = 'Added!';
        msgEl.textContent = 'Item added to your cart.';
        msgEl.className = 'skm-msg success';
        cartLink.className = 'skm-cart-link show';
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-count,[data-cart-count],.cart-item-count').forEach(function (el) { el.textContent = cart.item_count; });
        });
      })
      .catch(function (err) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
        msgEl.textContent = err.message || 'Could not add to cart.';
        msgEl.className = 'skm-msg error';
      });
  }

  function close() {
    getEls();
    if (!overlay) return;
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
